export enum SeatType {
  Entity,
  Seat,
  Workstation,
  Server,
  Mailbox,
  PhysicalWorkstation,
  PhysicalServer,
  VirtualServer,
  VirtualDesktop,
  ContainerHost,
  User,
  Endpoint,
  MobileDevice,
}
